import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/portfolio/Navigation";
import Hero from "@/components/portfolio/Hero";
import About from "@/components/portfolio/About";
import Services from "@/components/portfolio/Services";
import PortfolioGrid from "@/components/portfolio/PortfolioGrid";
import Skills from "@/components/portfolio/Skills";
import WhyHireMe from "@/components/portfolio/WhyHireMe";
import Testimonials from "@/components/portfolio/Testimonials";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import FloatingButtons from "@/components/portfolio/FloatingButtons";

function HomePage() {
  return (
    <div className="min-h-screen bg-[#09090B] text-white overflow-x-hidden">
      <Navigation />
      <main data-testid="main-content">
        <Hero />
        <About />
        <Services />
        <PortfolioGrid />
        <Skills />
        <WhyHireMe />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(18,18,20,0.95)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#FAFAFA",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
